export const UNION_MANAGEMENT_ROLES = Object.freeze(['leader', 'deputy', 'owner', 'admin']);
export const UNION_MEMBER_DATA_MANAGEMENT_ROLES = Object.freeze(['leader', 'deputy']);

const UNION_ROLE_LABELS = Object.freeze({
  leader: '주딱',
  deputy: '파딱',
  owner: '소유자',
  admin: '관리자',
  member: '멤버',
});

export function canManageUnion(role) {
  return UNION_MANAGEMENT_ROLES.includes(String(role || '').trim());
}

export function canManageUnionMemberData(role) {
  return UNION_MEMBER_DATA_MANAGEMENT_ROLES.includes(String(role || '').trim());
}

export function unionRoleLabel(role) {
  const normalized = String(role || '').trim();
  return UNION_ROLE_LABELS[normalized] || normalized || '멤버';
}
